export const ListQueryKey = 'raffletimes';
export const DetailQueryKey = 'raffletime';

export const Urls = {
  selectUrl: '/raffletime/list',
  updateUrl: '/raffletime/update',
  deleteUrl: '/raffletime/delete',
  createUrl: '/raffletime/create',
  detailUrl: '/raffletime/detail',
};
